exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-config-container[data-v-483c18f4]{max-width:1200px;margin:0 auto}.card-header[data-v-483c18f4]{margin-bottom:20px}.mt-10[data-v-483c18f4]{margin-top:10px}.mt-20[data-v-483c18f4]{margin-top:20px}.tab-content[data-v-483c18f4]{padding:20px;min-height:200px;background-color:#f5f7fa;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-483c18f4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/TabConfig.vue
// module id = OlIO
// module chunks = 1